import { autoinject } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { EntityValidationsService, ClientSideValidator } from "../../../client-validation-system/validations-service";
import { ValidationActivation, ValidationTypeEnum } from "../../../client-validation-system/validations.models";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { I18N } from 'aurelia-i18n';
import { Router } from "aurelia-router";

@autoinject
@transient()
export class ForgotPassword {

    email: string;
    password: string;
    validator: ClientSideValidator;
    sent: boolean = false;
    submitting: boolean;

    constructor(private requestClient: RequestClientService, private entityValidationsService: EntityValidationsService,
        private notificationService: NotificationClientService, private i18N: I18N, private router: Router) {
    }

    attached() {
        const rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "ForgotPassword",
            isCollection: false,
            nestedRulesHolder: [],
            rules: [{
                errorMessage: this.i18N.tr('email-required-text'),
                parameters: null, property: "email",
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: this.i18N.tr('email-invalid-text'),
                parameters: null, property: "email",
                validationType: ValidationTypeEnum.Email
            }]
        };
        this.validator = this.entityValidationsService.getValidator(this, rulesHolder);
    }

    signin() {
        this.router.navigate("/");
    }

    submit() {
        this.submitting = true;
        return new Promise<void>((resolve) => {
            this.validator.validate().then(validationResponse => {
                if (validationResponse.valid) {
                    const promise = this.requestClient.post("User/ForgotPassword", { email: this.email }) as Promise<any>;
                    promise.then(response => {
                        if (response && (response as any).isSuccess) {
                            this.submitting = false;
                            this.notificationService.show(this.i18N.tr('email-sent-successfully-text'), this.i18N.tr('email-sent-to-text') + " " + this.email, NotificationType.Success);
                            this.sent = true;
                        } else {
                            this.submitting = false;
                            this.notificationService.show(this.i18N.tr('error-text') + "!", this.i18N.tr('failed-to-send-email-text'), NotificationType.Error);
                        }
                        resolve();
                    }).catch(() => {
                        this.submitting = false;
                        this.notificationService.show(this.i18N.tr('error-text') + "!", this.i18N.tr('failed-to-send-email-text'), NotificationType.Error);
                        resolve();
                    });
                } else {
                    this.submitting = false;
                    resolve();
                }
            }).catch(() => {
                this.submitting = true;
                resolve();
            });
        });
    }
}
